import * as React from "react";
import { formInitialize, formSetValue, formUninitialize } from "../../gvc/testNewForm/utils";
import { domainToInput } from "./utils/utils";
import { DomainDraftContent } from "./draftContent";
import { store } from "../../../store";
import { request } from "../../../services/cpln";
import { v4 as uuidv4 } from "uuid";
import { useAppDispatch } from "../../../store/hooks";
import { formActions } from "../../../store/formSlice";

interface Props {}
export const DomainDraftInitializer: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const formIdRef = React.useRef(uuidv4());
  const [isInitialized, setIsInitialized] = React.useState<boolean>(false);
  React.useEffect(() => {
    const form = store.getState().form;
    const initialDomain = form.domain;
    formInitialize(formIdRef.current, domainToInput(initialDomain));
    setIsInitialized(true);
    return () => {
      dispatch(formActions.setDomain(undefined));
      formUninitialize(formIdRef.current);
    };
  }, []);

  React.useEffect(() => {
    // fetchGvcItem();
  }, [isInitialized]);

  async function fetchGvcItem() {
    try {
      const form = store.getState().form.instances[formIdRef.current];
      const values: any = form.values;
      const gvcLink = values.gvc.link;
      console.log("setting gvc item for link", gvcLink);
      if (gvcLink) {
        const { data } = await request({ url: gvcLink });
        console.log("gvc item", data);
        formSetValue(formIdRef.current, `gvc.item`, data);
      }
    } catch (e) {
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      console.log("failed to get alias of initial gvc", errorMessage);
    }
  }

  if (!isInitialized) {
    return null;
  }

  return <DomainDraftContent formId={formIdRef.current} />;
};
